import { useAppDispatch } from './state'
import { getQuestions as getQuestionsAPI } from '../api/questions'
import { setQuestions } from '../state/slices/questions_slice'

export const useQuestions = () => {
  const dispatch = useAppDispatch()

  const getQuestions = async () => {
    const result = await getQuestionsAPI()

    if (result.data) {
      dispatch(setQuestions(result.data))
    }
  }

  return {
    getQuestions
  }
}

export default useQuestions
